// The drawer, the sidebars and the page width animate as one move - a site with
// its own timing would visibly lag the others, so every layout transition uses these.
export const LAYOUT_TRANSITION_DURATION = '0.2s';
export const LAYOUT_TRANSITION_EASING = 'ease-out';

export const layoutTransition = (property: string): string =>
  `${property} ${LAYOUT_TRANSITION_DURATION} ${LAYOUT_TRANSITION_EASING}`;
